import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { useSelector, useDispatch } from 'react-redux'
import { Modal } from '../../../iba-components/Modal'
import { showPopBanner } from '../../../iba-components/PopBanner'
import { getMaster, checkContractRepresentativeEmail, insertClient, updateClient } from '../../api/client_managementV2'
import SignUpClientView from './SignUpClientView/signUpClientView'
import LoadingMask from '../../components/LoadingMask'
import './signUpClient.css'

import * as signUpClientActions from '../../actions/signUpClient'

const SignUpClient = ({ onSubmit, visible, title, handleCancel, initClientInfo }) => {
    const { t } = useTranslation()

    const [isLoading, setIsLoading] = useState(false)

    const signUpClient = useSelector((state) => state.signUpClientReducer)
    const userInfo = useSelector((state) => state.userInfo)

    const { isFetching, signUpClientData } = signUpClient

    const dispatch = useDispatch()

    const [signUpData, setSignUpData] = useState({})

    useEffect(() => {
        let mounted = true

        const fetchMasters = async () => {
            dispatch(signUpClientActions.fetch_sign_up_client_request())

            const getCountry = await getMaster({
                code: `JP`
            })

            return {
                country: getCountry.masterinfo.values
            }
        }

        if (!Object.keys(signUpClientData).length && mounted) {
            fetchMasters()
                .then(({ country }) => {
                    dispatch(
                        signUpClientActions.fetch_sign_up_client_success({
                            country
                        })
                    )
                })
                .catch((err) => {
                    dispatch(signUpClientActions.fetch_sign_up_client_failure(err))
                })
        }

        return () => (mounted = false)
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const submitSignUpClient = async (actionType, data) => {
        setIsLoading(true)
        setSignUpData({ ...signUpData, ...data })

        const checkDuplicateEmailRes = await checkContractRepresentativeEmail({
            contractrepresentativeemail1: data.contractrepresentativeemail1,
            clientid: data.clientid || ''
        }).catch((_e) => undefined)

        if (checkDuplicateEmailRes && !checkDuplicateEmailRes.hasError && !checkDuplicateEmailRes.isExists) {
            const res =
                actionType === 'insert'
                    ? await insertClient(data).catch((_e) => undefined)
                    : await updateClient(data).catch((_e) => undefined)
            setIsLoading(false)
            onSubmit && onSubmit()
            if (res?.hasError) {
                showPopBanner({
                    message: res.desc || t('signUpClient.warningMsg.registrationError'),
                    status: 'error',
                    duration: 2000
                })
                return
            }
            handleCancel('reloadClient')
            showPopBanner({
                message: t(`signUpClient.warningMsg.registrationSuccess`),
                status: 'success',
                duration: 2000
            })
        } else {
            setIsLoading(false)

            if (checkDuplicateEmailRes.isExists) {
                showPopBanner({
                    message: t(`signUpClient.warningMsg.duplicatedEmail`),
                    status: 'error',
                    duration: 5000
                })
            }
        }
    }

    const signUpClientContent = () => {
        return !isFetching && Object.keys(signUpClientData).length ? (
            <div className="edit-form-container sign-up-client">
                <SignUpClientView
                    onSubmit={submitSignUpClient}
                    clientInfo={initClientInfo}
                    userInfo={userInfo.userinfo}
                />
            </div>
        ) : (
            <div className="d-inline-flex align-items-center justify-content-center full-width sign-up-loading">
                <div className="a-loading a-primary"></div>
            </div>
        )
    }

    return (
        <Modal visible={visible} onCancel={handleCancel} title={title}>
            {signUpClientContent()}

            {isLoading ? <LoadingMask /> : ''}
        </Modal>
    )
}

SignUpClient.propTypes = {
    visible: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    handleCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func,
    initClientInfo: PropTypes.object,
    id: PropTypes.number
}

export default SignUpClient
